import { z } from 'zod';
import { UrlSettingsSchema } from '~schemas/settings';

export const LangUrlSettingsSchema = z.object({
  en: UrlSettingsSchema,
  fr: UrlSettingsSchema.optional(),
  nl: UrlSettingsSchema.optional(),
  da: UrlSettingsSchema.optional(),
});

export type LangUrlSettings = z.infer<typeof LangUrlSettingsSchema>;

export const FeatureFlagsSchema = z.object({
  legacy_results: z.boolean().default(true).optional(),
});

export type FeatureFlags = z.infer<typeof FeatureFlagsSchema>;

export const SettingsResponseSchema = z.object({
  mode: z.string(),
  urls: LangUrlSettingsSchema,
  features: FeatureFlagsSchema.default({
    legacy_results: false,
  }),
  skip_welcome: z.boolean().optional().default(false),
  skip_privacy: z.boolean().optional().default(false),
});

export type SettingsResponse = z.infer<typeof SettingsResponseSchema>;
